<template>
<div >
	<Loader :show="loading || saving"></Loader>
	<b-modal id="carCarRequestDispatchModal" :title="title" hide-footer no-close-on-backdrop no-close-on-esc @close="close">
		
        <b-form-group label="DUA Importación" >
			<b-form-input
				v-model="form.dua_dispatch"
				placeholder="Número de dua importación"
				:class="{'is-invalid':validation.hasError('form.dua_dispatch')}"
			></b-form-input>
			<b-form-invalid-feedback>Ingrese el número de dua</b-form-invalid-feedback>
		</b-form-group>

		<b-form-group label="Comprobante" >
			<UploadFile 
				v-model="form.file" 
				placeholder="Adjuntar comprobante"
				:invalid="validation.hasError('form.file.id')"
				:invalid-text="'Debe subir el comrpobante de despacho'"
			></UploadFile>
		</b-form-group>

        <div class="overflow-hidden mt-4">
            <b-button @click="close()" type="button" class="pull-left" size="sm" variant="light">Cancelar</b-button>
            <button type="submit" class="btn btn-primary pull-right" @click="save()" >Confirmar solicitud</button>
            
        </div>

	</b-modal>	
</div>
</template>

<script>
import gql from 'graphql-tag'
import mixins from '@/mixins/mixins'
import Loader from '@/components/Loader'
import UploadFile from '@/components/UploadFile'
import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;

export default {
	name: 'carCarRequestDispatchModal',
	components:{
		Loader,
		UploadFile
    },
    props:{
        carId:{
            required: true
        }
    },
    mixins: [mixins],
	data () {
		return {
			title: 'Solicitar despacho',
			show: false,
			loading:false,
			saving:false,
            id: null,
            form: {
				file:{
					id: null
				},
                dua_dispatch: null,
                cars:[]
			},
		}
    },
    validators: {
		'form.file.id': function (value) {
			return Validator.value(value).required();
		},
		'form.dua_dispatch': function (value) {
			return Validator.value(value).required();
        },
        'form.cars': function (value) {
			return Validator.custom( () => {
                if(value.length<=0){
					return true
				}
			})
		},
	},
	methods: {
		open () {
            this.form.cars.push(this.carId)
			this.showModal()
		},
		showModal() {
			this.show = true
			this.$bvModal.show('carCarRequestDispatchModal')
		},
		close () {
			this.show = false
			this.form = {
                file:{
					id: null
				},
                dua_dispatch: null,
                cars:[]
            }
			this.$bvModal.hide('carCarRequestDispatchModal')
        },
        disabledPeriodDate(date) {
			var yesterday = new Date()
			yesterday.setDate(yesterday.getDate())
			return date < yesterday
		},
        async save () {
			if(!this.saving && await this.checkValidation() ) {
				this.saving = true
				
				let dataInput = {
					dua_dispatch: this.form.dua_dispatch,
                    file_id     : this.form.file.id,
					cars: 						this.form.cars
				}
				this.create(dataInput)
			}
		},
		create (data) {
			this.$apollo.mutate({
				mutation: gql`mutation ( $data:RequestDispatchInput! ){
					requestDispatch( data: $data) {
						id
					}
				}`,
				variables: {
					data
				}
			})
			.then(() => {
				this.$toast.success('Solicitud realizada correctamente')
                this.$emit('changed')
                this.close()
				this.saving = false
			})
			.catch( (error) => {
				this.errors = this.parseGQLErrors(error)
				this.$toast.error('Error!')
				this.saving = false
			})

		},
	}
}


</script>
